import { Base } from "../core/base.model";
import { Usuario } from "../security/usuario.model";
import { Persona } from "../security/persona.model";

export class UsuarioClienteBean extends Base{
     id_usuario: number;
     id_cliente: number;
     nuevo_id_cliente: number;
     id_persona: number;
     user_nom: string;
     nom_persona: string;
     nom_cliente: string;
     num_corporativo: string;
     a_paterno: string;
     a_materno: string;
     nombreCompleto: string;
     usuarioBean: Usuario;
     personaBean: Persona;
     estatus: string;
     img: string;
     correo: string;
     nom_proyecto: string;
     id_proyecto: number;
}